<template>
  <div>
    <van-search
      v-model="searchString"
      show-action
      placeholder="请输入收款方"
      @search="getPaymentRecord"
      @cancel="cancelSearch"
    />
    <van-row class="filter-nav">
      <van-col :span="8">付款类别
        <van-icon name="arrow"/>
      </van-col>
      <van-col :span="8">状态
        <van-icon name="arrow"/>
      </van-col>
      <van-col :span="8" @click="showFilterPanel=true">筛选
        <van-icon name="arrow"/>
      </van-col>
    </van-row>
    <ul class="record-list">
      <li class="record-item" v-for="(item,i) in payList" :key="i">
        <van-row class="text-primary">
          <van-col :span="12">{{item.RPerName}}</van-col>
          <van-col :span="12" class="text-right">{{item.Record}}</van-col>
        </van-row>
        <van-row class="mt10 text-lightgray" type="flex" align="center" justify="center">
          <van-col :span="8">总金额：{{currencycon(item.SumAmount,'',2)}}</van-col>
          <van-col :span="8" class="text-center">{{item.Currency}}</van-col>
          <van-col :span="8" class="text-right">{{item.InvType.slice(0,4)}}</van-col>
        </van-row>
        <van-row class="mt10">
          <van-col :span="7" class="van-ellipsis text-lightgray">{{item.InvTypeDts}}</van-col>
          <van-col :span="10" class="text-center text-lightgray">确认日期：{{item.Date}}</van-col>
          <van-col :span="7" class="text-right">
            <span class="text-primary" @click="editRecord(item)">编辑</span>
            <span class="ml10 text-danger" @click="delRecord(item)">删除</span>
            <span class="ml10 text-primary" @click="voucher(item.RP_GUID)">凭证</span>
          </van-col>
        </van-row>
      </li>
    </ul>
    <van-dialog v-model="showVoucher" title="凭证查看">
      <div style="padding:1rem">
        <van-row class="h6">
          <van-col :span="12">核算单位：{{userName}}</van-col>
          <van-col :span="12" class="text-right">日期：{{datecon.slice(0,11)}}</van-col>
        </van-row>
        <van-row class="h6 mt10">
          <van-col :span="6">摘要</van-col>
          <van-col :span="5">会计科目</van-col>
          <van-col :span="5">二级科目</van-col>
          <van-col :span="4">借方金额</van-col>
          <van-col :span="4">贷方金额</van-col>
        </van-row>
        <van-row class="h6 mt10" v-for="(item,i) in sectioncon" :key="i">
          <van-col :span="6">{{item.Summary}}</van-col>
          <van-col :span="5">{{item.Name}}</van-col>
          <van-col :span="5">{{item.ThName===null?item.DetailName:item.DetailName+'-'+item.ThName}}</van-col>
          <van-col :span="4">{{currencycon(item.DebitAmount===0?'':item.DebitAmount,'',2)}}</van-col>
          <van-col :span="4">{{currencycon(item.CreditAmount===0?'':item.CreditAmount,'',2)}}</van-col>
        </van-row>
        <van-row class="h6 mt10">
          <van-col :span="16">{{numToCny(DebitsAmount)}}</van-col>
          <van-col :span="4">{{currencycon(DebitsAmount,'',2)}}</van-col>
          <van-col :span="4">{{currencycon(CreditsAmount,'',2)}}</van-col>
        </van-row>
        <van-row class="h6 mt10">
          <van-col :span="8">财务主管：{{userName}}</van-col>
          <van-col :span="8">记账：{{userName}}</van-col>
          <van-col :span="8">复核：{{userName}}</van-col>
        </van-row>
        <van-row class="mt10 h6">
          <van-col :span="8">出纳：{{userName}}</van-col>
          <van-col :span="8">制单：{{userName}}</van-col>
          <van-col :span="8">经办人：{{userName}}</van-col>
        </van-row>
      </div>
    </van-dialog>
    <van-popup v-model="showFilterPanel" position="right" :style="{ height: '100%',width:'80%' }">
      <h2>条件筛选</h2>
      <ul>
        <li class="incon1">
          <input class="js-startdate-picker" type="text" placeholder="付款日期" v-model="selectBirthDate" readonly>
          <a href="javascript:;"><img src="../../../static/img/images/isbotjian.png" alt=""></a>
        </li>
        <li class="incon1">
          <input class="js-enddate-picker" type="text" placeholder="结束时间" v-model="enddate" readonly>
          <a href="javascript:;"><img src="../../../static/img/images/isbotjian.png" alt=""></a>
        </li>
        <li class="incon2">
          <input type="text" placeholder="付款类别" id="btncon" @click="toShow" ref="incomeGrp" readonly>
          <vue-pickers
            :show="show"
            :columns="columns"
            :defaultData="defaultData"
            :selectData="pickData"
            @cancel="close"
            @confirm="confirmFn"></vue-pickers>
        </li>
        <li class="incon2">
          <input type="text" placeholder="付款子类别" readonly>
        </li>
        <li class="incon2">
          <input type="text" placeholder="收款方" id="btncon1" @click="toCus" ref="customer" readonly>
          <vue-pickers
            :show="isshow"
            :columns="columns"
            :selectData="customercon"
            @cancel="close1"
            @confirm="concus">
          </vue-pickers>
        </li>
        <li class="incon2">
          <input type="text" placeholder="销账状态" id="btncon3" @click="tostate" ref="state" readonly>
          <vue-pickers
            :show="isshow3"
            :columns="columns"
            :selectData="statecon"
            @cancel="close3"
            @confirm="stateCon">
          </vue-pickers>
        </li>
      </ul>
      <van-row class="filter-btns">
        <van-col :span="12">
          <van-button block>重置</van-button>
        </van-col>
        <van-col :span="12">
          <van-button type="primary" block @click="btn()">确定</van-button>
        </van-col>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
  import vuePickers from 'vue-pickers'
  import {getPaymentRecordFun, getALLVoucherFun, delPaymentRecordFun} from '@/api/payment'
  import {Dialog} from 'vant';

  export default {
    components: {
      vuePickers
    },
    data() {
      return {
        searchString: '',//搜索的内容
        showFilterPanel: false,//是否显示右侧过滤面板
        showVoucher: false,//查看凭证
        payList: [],
        userName: this.getCookie('UserInfo').NickName || '',
        //==========================================//
        sectioncon: [],
        section: [],
        datecon: '',
        DebitsAmount: '',
        CreditsAmount: '',

        show: false,
        isshow: false,
        isshow3: false,
        columns: 1,
        isCopy: '',
        defaultData: [
          {
            text: '全部',
            value: '全部'
          }
        ],
        pickData: {
          // 第一列的数据结构
          data1: [
            {
              text: '全部',
              value: '全部'
            },
            {
              text: '未归类',
              value: '未归类'
            },
            {
              text: '内部转账',
              value: '内部转账'
            },
            {
              text: '经营活动收款',
              value: '经营活动收款'
            },
            {
              text: '投资活动收款',
              value: '投资活动收款'
            },
            {
              text: '筹资活动收款',
              value: '筹资活动收款'
            },
          ]
        },
        customercon: {
          data1: [{
            text: '1111',
            value: '1111'
          }]
        },
        statecon: {
          data1: [
            {
              text: '全部',
              value: '全部'
            },
            {
              text: '未销账',
              value: '未销账'
            },
            {
              text: '已销账',
              value: '已销账'
            }
          ]
        },
        res: null,
        enddate: '',
        selectBirthDate: '',
        currencyList: [],
        customerList: [],
      }
    },
    mounted() {
      // this.BirthDateSelect();
      // this.BirthEndDateSelect();
      // this.GetCustomer()
      this.getPaymentRecord()
    },
    methods: {
      //凭证关闭按钮
      closebtn() {
        var sectioncon = document.getElementById('sectioncon');
        var Mask = document.getElementById('Mask');
        sectioncon.style.display = 'none';
        Mask.style.display = 'none';
      },
      //凭证获取按钮
      async voucher(RP_GUID) {
        const params = {
          C_GUID: this.getCookie('CompanyInfo').companyId,
          Date: '',
          M_GUID: RP_GUID,
          VouchGuid: ''
        };
        let response = await getALLVoucherFun(params);
        if (response.success) {
          this.datecon = response.result[0].Date.replace(/-/g, "/").replace(/-/g, "/").replace(/-/g, "")
          this.sectioncon = response.result;
          this.section = this.sectioncon.pop()
          this.DebitsAmount = JSON.stringify(this.section.DebitAmount)
          this.CreditsAmount = JSON.stringify(this.section.CreditAmount)
          this.showVoucher = true;
        }
      },
      //  删除
      delRecord(record) {
        Dialog.confirm({
          message: '确定删除该记录吗？',
        }).then(async () => {
          const params = {
            GUID: record.RP_GUID,
            C_GUID: this.getCookie('CompanyInfo').companyId,
            InvType: this.InvType
          };
          const response = await delPaymentRecordFun(params);
          if (response.success) {
            this.getPaymentRecord();
          }
        })
      },
      //编辑
      editRecord(record) {
        this.$router.push({path: '/payment/paycon'})
      },
      //获取到付款的全部数据
      async getPaymentRecord() {
        let params = {
          pageSize: 100,
          pageIndex: 1,
          C_GUID: this.getCookie('CompanyInfo').companyId,
          record: '',
          dateBegin: '',
          dateEND: '',
          customer: '',
          incomeGrp: '',
          InvTypeDts: '',
          RP_GUID: '',
          customerName: this.searchString,//this.$refs.inputcon.value
        };
        let response = await getPaymentRecordFun(params);
        if (response.success) {
          console.log(response);
          this.payList = response.result
        }
      },
      //跳转到申请成本外支出
      apply() {
        this.$router.push({path: '/apply'})
      },
      //开始时间
      BirthDateSelect() {
        var calendar = new datePicker();
        calendar.init({
          trigger: ".js-startdate-picker", /*按钮选择器，用于触发弹出插件*/
          type:
            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
          minDate: "1900-1-1" /*最小日期*/,
          maxDate: "2100-12-31" /*最大日期*/,
          onSubmit: function () {
            /*确认时触发事件*/
            var theSelectData = calendar.value;
          },
          onClose: function () {
            /*取消时触发事件*/
          }
        });
      },
      //结束时间
      BirthEndDateSelect() {
        var calendar = new datePicker();
        calendar.init({
          trigger: ".js-enddate-picker", /*按钮选择器，用于触发弹出插件*/
          type:
            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,
          minDate: "1900-1-1" /*最小日期*/,
          maxDate: "2100-12-31" /*最大日期*/,
          onSubmit: function () {
            /*确认时触发事件*/
            var theSelectData = calendar.value;
          },
          onClose: function () {
            /*取消时触发事件*/
          }
        });
      },
      //付款类别的关闭
      close() {
        console.log(123)
        this.show = false
      },
      //收款方的关闭
      close1() {
        console.log(123)
        this.isshow = false
      },
      //销账状态的关闭
      close3() {
        console.log(123)
        this.isshow3 = false
      },
      //付款类别的显示选择
      confirmFn(val) {
        var btn = document.getElementById('btncon')
        console.log(val.select1.value)
        this.show = false
        btn.value = val.select1.value
        this.res = btn.value
        // console.log(JSON.parse(this.defaultData))
        this.defaultData = [val.select1[0]]
      },
      //收款方的类别显示选择
      concus(val) {
        var btn2 = document.getElementById('btncon1')
        console.log(val.select1.value)
        this.isshow = false
        btn2.value = val.select1.value
        this.res = btn2.value
        // console.log(JSON.parse(this.defaultData))
      },
      //状态显示选择
      stateCon(val) {
        var btn4 = document.getElementById('btncon3')
        this.isshow3 = false
        btn4.value = val.select1.value
        this.res = btn4.value
        // console.log(JSON.parse(this.defaultData))
      },
      //付款类别的显示
      toShow(val) {
        this.show = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      //收款方的显示
      toCus(val) {
        this.isshow = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      //状态的显示
      tostate(val) {
        this.isshow3 = true
        // var btn=document.getElementById('btn')
        // console.log(val)
        // this.res = btn.value
      },
      //取消搜索
      cancelSearch() {
        this.searchString = '';
        this.getPaymentRecord()
      },
      //点击筛选条件获取付款数据
      btn() {
        this.$axios({
          method: 'post',
          url: '/fmsapi/PaymentRecord/GetPaymentRecord',
          data: this.$qs.stringify({
            pageSize: '-1',
            pageIndex: '1',
            C_GUID: sessionStorage.getItem('companyId'),
            record: '',
            dateBegin: this.selectBirthDate,
            dateEND: this.enddate,
            customer: '',
            incomeGrp: this.$refs.incomeGrp.value,
            InvTypeDts: '',
            RP_GUID: '',
            customerName: this.$refs.customer.value,
          })
        }).then(res => {
          console.log(this.$refs.customer.value)
          var bothbox = document.getElementById('bothbox');
          var boxcon1 = document.getElementById("boxcon1")
          bothbox.style.transform = "translate(2.68rem,0)"
          boxcon1.style.display = 'none'
          this.$refs.incomeGrp.value = ''
          this.$refs.customer.value = ''
          this.selectBirthDate = ''
          this.enddate = ''
          this.payList = res.data.result
          console.log(this.payList.length)
        })
      },
      //获取货币
      getcurrency() {
        var currency = document.getElementById('currency')
        this.$axios.post('/fmsapi/common/GetSearchCurrency').then(res => {
          this.currencyList = res.data.result
          this.currencyCon.data1 = new Array();
          for (var i = 0; i < this.currencyList.length; i++) {
            this.currencyCon.data1.push({"text": this.currencyList[i].Code, "value": this.currencyList[i].Code})
          }

        })
      },
      //获取到收款方
      GetCustomer() {
        var custormlog = document.getElementById('custormlog')
        this.$axios({
          method: 'post',
          url: '/fmsapi/common/GetPayeeJson',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId')
          })
        }).then(res => {
          this.customerList = res.data.result
          // custormlog.style.display="block"
          this.customercon.data1 = new Array();
          for (var i = 0; i < this.customerList.length; i++) {
            this.customercon.data1.push({"text": this.customerList[i].Name, "value": this.customerList[i].Name})
          }
        })
      },
      //转换器
      currencycon(value, currency, decimals) {
        const digitsRE = /(\d{3})(?=\d)/g
        value = parseFloat(value)
        if (!isFinite(value) || (!value && value !== 0)) return ''
        currency = currency != null ? currency : '$'
        decimals = decimals != null ? decimals : 2
        var stringified = Math.abs(value).toFixed(decimals)
        var _int = decimals
          ? stringified.slice(0, -1 - decimals)
          : stringified
        var i = _int.length % 3
        var head = i > 0
          ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
          : ''
        var _float = decimals
          ? stringified.slice(-1 - decimals)
          : ''
        var sign = value < 0 ? '-' : ''
        return sign + currency + head +
          _int.slice(i).replace(digitsRE, '$1,') +
          _float
      },
    }
  }
</script>

<style lang="less" scoped>
  .filter-nav {
    background: white;
    text-align: center;
    padding: 1rem 0;
    margin-top: 1rem;

    .filter-btns {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  .record-list {
    background: white;
    margin-top: 1rem;
    flex: 1;
    overflow: auto;

    .record-item {
      padding: 1rem;
      border-top: solid 1px #f0f0f0;
    }
  }

</style>
